
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { saveAs } from 'file-saver';
import * as moment from 'moment';
import { NGXLogger } from 'ngx-logger';
import { FileUpload } from "primeng/components/fileupload/fileupload";
import { Subscription } from 'rxjs';
import { ContractFile } from '../../../models/contract-file.model';
import { Customer } from '../../../models/customer.model';
import { EANCode } from '../../../models/ean-code.model';
import { ElectricityContract } from '../../../models/electricity-contract.model';
import { MeterType } from '../../../models/meter-type.model';
import { Permission } from '../../../models/permission.model';
import { SPElectricityContract } from '../../../models/sp-electricity-contract';
import { Supplier } from '../../../models/supplier.model';
import { AccountService } from '../../../services/account.service';
import { AlertService, DialogType, MessageSeverity } from '../../../services/alert.service';
import { fadeInOut } from '../../../services/animations';
import { AuthService } from '../../../services/auth.service';
import { ContractFileService } from '../../../services/contract-file.service';
import { CustomersService } from '../../../services/customers.service';
import { EANCodeService } from '../../../services/ean-code.service';
import { ElectricityContractService } from '../../../services/electricity-contract.service';
import { MeterTypeService } from '../../../services/meter-type.service';
import { ScrollService } from '../../../services/scroll.service';
import { SupplierService } from '../../../services/supplier.service';

@Component({
    selector: 'injectie-contract',
    template: require('./injectie-contract.component.html'),
    styles: [require('./injectie-contract.component.css')],
    animations: [fadeInOut]
})
export class InjectieContractComponent implements OnInit, OnDestroy {
    private subscribers: Subscription[] = [];
    mode: string = "Toevoegen";
    electricityContract: ElectricityContract = new ElectricityContract();
    spelectricityContracts: SPElectricityContract[] = [];
    electricityContracts: ElectricityContract[] = [];
    meterTypes: MeterType[] = [];
    suppliers: any[] = [];
    dtuploadedFiles: any[] = [];
    uploadedFiles: any[] = [];
    loading: boolean = false;
    loadingEndex: boolean = false;
    uploadUrl: string = "api/ContractFile/UploadFile/3"; // 3: Injection Electricity
    yearRange: string = (new Date().getFullYear() - 5) + ':' + (new Date().getFullYear() + 30);
    isEditablePermission: boolean = false;

    @ViewChild('fileInput') fileInput: FileUpload;
    eanCodes: EANCode[] = [];

    constructor(private electricityContractService: ElectricityContractService,
        private meterTypeService: MeterTypeService, private supplierService: SupplierService, private contractFileService: ContractFileService,
        private customersService: CustomersService, private eanCodeService: EANCodeService, private accountService: AccountService, private authService: AuthService,
        private router: Router, private activatedRoute: ActivatedRoute, private alertService: AlertService, private ngxLogger: NGXLogger, private scrollService: ScrollService) {
    }

    ngOnInit(): void {
        this.isEditablePermission = this.caninjectionContractAddPermission;
        const ecid = this.activatedRoute.snapshot.params["ecid"];
        if (ecid) {
            this.mode = "Bewerk";
        }

        const meterTypeSubscriber = this.meterTypeService.get().subscribe((res: MeterType[]) => {
            this.meterTypes = res;
        }, error => {
            this.ngxLogger.error(error.message);
            throw error;
        });
        this.subscribers.push(meterTypeSubscriber);
        this.setInitValue();
    }

    setInitValue() {
        this.electricityContract.ContractBase.FacilityTypeId = 3; // 1: Injectie contract

        const cid = this.activatedRoute.snapshot.params["cid"];
        if (cid) {
            this.electricityContract.ContractBase.CustomerId = cid;
            this.getCustomerById();
            this.getEanCodesByCustomerAndEANCodeType();
        }

        const cType = this.activatedRoute.snapshot.params["ctype"];
        if (cType) {
            this.electricityContract.CType = cType.toUpperCase();
        }

        const getAllFacilitySubscriber = this.supplierService.getAllByFacilityType(1).subscribe((res: Supplier[]) => {
            const _suppliers = new Array<any>();
            res.forEach((s: Supplier) => {
                _suppliers.push({ label: s.Name, value: s.Id });
            });
            this.suppliers = _suppliers;
            if (this.suppliers && this.suppliers.length > 0 && this.electricityContract.Id == 0) {
                this.electricityContract.ContractBase.SupplierId = this.suppliers[0].value;
            }
        }, error => {
            this.ngxLogger.error(error.message);
            throw error;
        });
        this.subscribers.push(getAllFacilitySubscriber);
        setTimeout(() => {
            if (cid) {
                this.getAllByCustomer(cid);
            } else {
                this.getAll();
            }
        }, 500);
    }

    getAll() {
        this.loading = true;
        const getAllEleSubscriber = this.electricityContractService.getAll().subscribe((res: ElectricityContract[]) => {
            if (res != null && res.length > 0) {
                this.electricityContracts = res.filter(c => c.ECType == "I");
                this.loading = false;
                this.setElectricityContract();
            }
        }, error => {
            this.loading = false;
            this.ngxLogger.error(error.message);
            throw error;
        });
        this.subscribers.push(getAllEleSubscriber);
    }

    getAllByCustomer(customerId: number) {
        this.loading = true;
        const getFilteredSubscriber = this.electricityContractService.getFiltered(customerId, 3).subscribe((res: SPElectricityContract[]) => {

            if (res != null && res.length > 0) {
                this.spelectricityContracts = res.filter(c => c.ECType == "I");
                this.loading = false;
                this.setElectricityContract();
            }
        }, error => {
            this.loading = false;
            this.ngxLogger.error(error.message);
            throw error;
        });
        this.subscribers.push(getFilteredSubscriber);
    }

    getCustomerById() {
        const getByIdSubscriber = this.customersService.getById(this.electricityContract.ContractBase.CustomerId).subscribe((res: Customer) => {
            this.electricityContract.ContractBase.Customer = res;
        }, error => {
            this.ngxLogger.error(error.message);
            throw error;
        });
        this.subscribers.push(getByIdSubscriber);
    }

    getEanCodesByCustomerAndEANCodeType() {
        const getEANByCustSubscriber = this.eanCodeService.getEanCodesByCustomerAndEANCodeType(this.electricityContract.ContractBase.CustomerId, 3, this.electricityContract.CType)
            .subscribe((res: EANCode[]) => {
                this.electricityContract.SourceEanCodes = res;
                this.electricityContract.TargetEanCodes = [];
                this.eanCodes = res;
            }, error => {
                this.ngxLogger.error(error.message);
                throw error;
            });
        this.subscribers.push(getEANByCustSubscriber);
    }

    setElectricityContract() {
        const ecid = this.activatedRoute.snapshot.params["ecid"];
        if (ecid) {
            this.isEditablePermission = this.caninjectionContractEditPermission;
            const cbidSubscriber = this.electricityContractService.getElectricityContractByContractId(ecid).subscribe((electricityContract: ElectricityContract) => {
                if (electricityContract) {
                    this.edit(electricityContract);
                }
            }, error => {
                this.ngxLogger.error(error.message);
                throw error;
            });
            this.subscribers.push(cbidSubscriber);
            // const _electricityContract = this.electricityContracts.filter(ec => ec.ContractBaseId == ecid)[0];
        }
    }

    SetEditByID(cid: number) {
        const vmByIDSubscriber = this.electricityContractService.getElectricityContractVMByContractId(cid).subscribe((electricityContract: ElectricityContract) => {
            if (electricityContract) {
                this.electricityContract = electricityContract;
                this.edit(electricityContract);
            }
        }, error => {
            this.ngxLogger.error(error.message);
            throw error;
        });
        this.subscribers.push(vmByIDSubscriber);
    }

    createUpdate(form: NgForm) {
        if (this.isEditablePermission) {
            if (this.electricityContract.Id == 0 && this.electricityContract.TargetEanCodes.length == 0) {
                this.alertService.showMessage("Elektriciteitscontract", "Please select EAN Code", MessageSeverity.error);
                return false;
            }
            if (this.electricityContract.ContractBase && this.electricityContract.ContractBase.Customer.ContractBases) {
                this.electricityContract.ContractBase.Customer.ContractBases = undefined;
            }
            if (this.electricityContract.TariffSingleUse || (this.electricityContract.TariffPeakConsumption && this.electricityContract.TariffLowConsumption)) {
                this.electricityContract.ECType = "I";

                const cuSubscriber = this.electricityContractService.createUpdate(this.electricityContract).subscribe((res: ElectricityContract) => {
                    if (res) {
                        this.alertService.showMessage('Elektriciteitscontract', 'Veranderingen succesvol opgeslagen!', MessageSeverity.success);
                        this.electricityContract = res;
                        this.fileInput.url = "api/ContractFile/UploadFile/3/" + res.ContractBaseIds;
                        this.electricityContract.ContractBase.ContractDate = moment.utc(this.electricityContract.ContractBase.ContractDate).toDate();
                        this.electricityContract.ContractBase.ContractStartDate = moment.utc(this.electricityContract.ContractBase.ContractStartDate).toDate();
                        this.electricityContract.ContractBase.ContractEndDate = moment.utc(this.electricityContract.ContractBase.ContractEndDate).toDate();

                        if (this.fileInput.files.length > 0) {
                            // FILE UPLOADING
                            this.fileInput.upload();
                        }

                        // REFRESH CONTRACT FILES
                        // setTimeout(() => {
                        //     this.refreshContractFile(res.Id);
                        // }, 1000);

                        this.resetForm(form);
                        this.setInitValue();
                        this.fileInput.clear();
                        // REFRESH LIST
                        this.getAllByCustomer(this.electricityContract.ContractBase.CustomerId);
                    }
                }, error => {
                    this.ngxLogger.error(error.message);
                    throw error;
                });
                this.subscribers.push(cuSubscriber);
            } else {
                this.alertService.showMessage("Elektriciteitscontract", "Ofwel is het enkelvoudig tarief verbruik of Piek/DAL verbruik vereist.", MessageSeverity.error);
            }
        }
    }

    edit(ec: ElectricityContract) {
        this.scrollService.scrollTop();
        this.electricityContract = ec;
        this.electricityContract.ContractBase.ContractDate = moment.utc(this.electricityContract.ContractBase.ContractDate).toDate();
        this.electricityContract.ContractBase.ContractStartDate = moment.utc(this.electricityContract.ContractBase.ContractStartDate).toDate();
        this.electricityContract.ContractBase.ContractEndDate = moment.utc(this.electricityContract.ContractBase.ContractEndDate).toDate();
        this.getContractFiles(ec.ContractBaseId);
        // SET ENDEX
        // this.getEndexByDate(this.electricityContract.ContractBase.ContractDate, true);

        // FILE UPLOADING
        this.uploadUrl = 'api/ContractFile/UploadFile/3/' + ec.Id.toString();
        this.mode = "Bijwerken";

        // REFRESH CONTRACT FILES
        // this.refreshContractFile(ec.Id);
    }

    viewFile(cid: number) {
        this.alertService.showMessage('Injectiecontract', 'Even geduld aub terwijl we een bestand van de server krijgen!', MessageSeverity.info);
        const getAllFSubscriber = this.contractFileService.getAllByFacility(3, cid).subscribe((res: any[]) => {
            if (res.length > 0) {
                this.alertService.showMessage('Injectiecontract', 'Downloaden van bestanden is bezig!', MessageSeverity.info);
                if (res.length == 1) { // VIEW SINGLE FILE
                    const vfSubscriber = this.contractFileService.viewFile(1, cid, res[0].Id).subscribe(data => {
                        const url = window.URL.createObjectURL(data);
                        const iFrameElement = <HTMLIFrameElement>document.getElementById('iFrameContent');
                        iFrameElement.setAttribute('src', url);
                        iFrameElement.setAttribute('type', data.type);
                        (<HTMLButtonElement>document.getElementById('btnmyModelPopup')).click();
                    }, error => {
                        this.ngxLogger.error(error.message);
                        throw error;
                    });
                    this.subscribers.push(vfSubscriber);
                } else if (res.length > 1) {  // DOWNLOAD ZIP
                    const dZSubscriber = this.electricityContractService.downloadZip(3, cid).subscribe(data => {
                        saveAs(data, 'InjectieContracts.zip');
                        this.alertService.showMessage('Injectiecontract', 'Bestandsdownload voltooid!', MessageSeverity.info);
                    }, error => {
                        this.ngxLogger.error(error.message);
                        throw error;
                    });
                    this.subscribers.push(dZSubscriber);
                }
            } else {
                this.alertService.showMessage('Injectiecontract', 'Geen document gevonden voor dit contract!', MessageSeverity.info);
            }
        }, error => {
            this.ngxLogger.error(error.message);
            throw error;
        });
        this.subscribers.push(getAllFSubscriber);
    }

    previewFile(cFile: ContractFile) {
        const elSubscriber = this.electricityContractService.getElectricityContractById(cFile.ContractId).subscribe((elContract: ElectricityContract) => {
            const vfileSubscriber = this.contractFileService.viewFile(cFile.FacilityTypeId, cFile.ContractBaseId, cFile.Id).subscribe(data => {
                const url = window.URL.createObjectURL(data);
                const iFrameElement = <HTMLIFrameElement>document.getElementById('iFrameContent');
                iFrameElement.setAttribute('src', url);
                iFrameElement.setAttribute('type', data.type);
                (<HTMLButtonElement>document.getElementById('btnmyModelPopup')).click();
            }, error => {
                this.ngxLogger.error(error.message);
                throw error;
            });
            this.subscribers.push(vfileSubscriber);
        });
        this.subscribers.push(elSubscriber);
    }

    private getFileExtensionFromContentType(contentType: string) {
        let fileExtension: string;
        switch (contentType.toLowerCase()) {
            case 'image/png':
                fileExtension = '.png';
                break;
            case 'image/gif':
                fileExtension = '.gif';
                break;
            case 'image/jpeg':
            case 'image/jpg':
                fileExtension = '.jpg';
                break;
            case 'application/pdf':
                fileExtension = '.pdf';
                break;

            default:
                fileExtension = '.pdf';
                break;
        }
        return fileExtension;
    }

    getContractFiles(contractId: number) {
        const getAllByFacilitySubscriber = this.contractFileService.getAllByFacility(3, contractId).subscribe((res: any[]) => {
            this.dtuploadedFiles = res;
        }, error => {
            this.ngxLogger.error(error.message);
            throw error;
        });
        this.subscribers.push(getAllByFacilitySubscriber);
    }

    deleteContractFile(Id: number, contractId: number, fileName: string, FileNameInternal: string) {
        this.alertService.showDialog('Weet je zeker dat je wilt verwijderen?', DialogType.confirm, () => {
            const removeByIdSubscriber = this.contractFileService.removeById(Id, contractId, fileName, FileNameInternal).subscribe((res: boolean) => {
                this.getContractFiles(contractId);
                this.alertService.showMessage('Contract File', 'Met succes verwijderd!', MessageSeverity.success);
            }, error => {
                this.ngxLogger.error(error.message);
                throw error;
            });
            this.subscribers.push(removeByIdSubscriber);
        });
    }

    // refreshContractFile(contractId: number) {
    //     this.contractFileService.getAllByFacility(3, contractId).subscribe((res: any[]) => {
    //        this.uploadedFiles = res;
    //     }, error => {
    //        this.ngxLogger.error(error.message);
    //        throw error;
    //     });
    // }

    delete(id: number) {
        this.alertService.showDialog('Weet je zeker dat je wilt verwijderen?', DialogType.confirm, () => {
            const deleteSubscriber = this.electricityContractService.delete(id).subscribe(res => {
                this.alertService.showMessage('Elektriciteitscontract', 'Met succes verwijderd!', MessageSeverity.success);
                this.router.navigate(['injectiecontract', this.electricityContract.ContractBase.CustomerId]);
                // this.getAllByCustomer(this.electricityContract.ContractBase.CustomerId, true);
                // this.electricityContract = new ElectricityContract();
            }, error => {
                this.ngxLogger.error(error.message);
                throw error;
            });
            this.subscribers.push(deleteSubscriber);
        });
    }

    resetForm(form: NgForm) {
        this.scrollService.scrollTop();
        form.resetForm();
        this.electricityContract = new ElectricityContract;
        this.uploadedFiles = [];
        const cid = this.activatedRoute.snapshot.params["cid"];
        if (cid) {
            this.electricityContract.ContractBase.CustomerId = cid;
            this.getCustomerById();
            this.getEanCodesByCustomerAndEANCodeType();
        }
        this.mode = "Toevoegen";
        this.uploadUrl = "api/ContractFile/UploadFile/3"; // 1: Electricity

        this.electricityContract.ContractBase.SupplierId = this.suppliers[0].value;
        this.electricityContract.ContractBase.FacilityTypeId = 3;
    }

    onUpload(event) {
        this.fileInput.clear();
        this.alertService.resetStickyMessage();
        this.alertService.showMessage("Elektriciteitscontract", "Bestand succesvol geüpload", MessageSeverity.success);
        for (let file of event.files) {
            this.uploadedFiles.push(file);
        }
        // const cid = this.activatedRoute.snapshot.params["cid"];
        // if (cid) {
        //     // REFRESH LIST
        //     this.getAllByCustomer(cid);
        // }
    }

    onProgress(event) {
        this.alertService.resetStickyMessage();
        if (event.progress) {
            this.alertService.showStickyMessage("Elektriciteitscontract", `Het uploaden van bestanden is bezig, ${event.progress}% bestandsupload`, MessageSeverity.wait);
        }
    }

    onError(event) {
        this.fileInput.clear();
        this.alertService.resetStickyMessage();
        this.alertService.showStickyMessage("Elektriciteitscontract", "Uploaden van bestanden is mislukt", MessageSeverity.warn);
    }

    getSizeInMegaBytes(size: number) {
        return size / 1000000;
    }

    deleteFile(file: any) {
        this.alertService.showDialog('Ben je zeker om het bestand te verwijderen: ' + file.FileName + '?', DialogType.confirm, () => {
            const deleteSubscriber = this.contractFileService.delete(file.Id).subscribe(res => {
                if (res) {
                    this.alertService.showMessage('Contract bestand', 'Met succes verwijderd!', MessageSeverity.success);
                    const index = this.uploadedFiles.indexOf(file);
                    if (index !== -1) {
                        this.uploadedFiles.splice(index, 1);
                    }
                }
            }, error => {
                this.ngxLogger.error(error.message);
                throw error;
            });
            this.subscribers.push(deleteSubscriber);
        });
    }

    getEndexByDate(value: Date, isInit: boolean) {
        this.loadingEndex = true;
        const contractDate = moment(value).format("YYYY-MM-DD");
        const getEndexSubscriber = this.electricityContractService.getEndexByDate(contractDate).subscribe((res: number) => {
            if (res > 0) {
                if (this.authService.currentUser && this.authService.currentUser.IsTrial) {
                    this.setTrialUserEndex(isInit);
                } else {
                    this.electricityContract.Endex = res;
                }
            } else {
                this.electricityContract.Endex = null;
                if (!isInit) {
                    this.alertService.showMessage('Elektriciteitscontract', 'Geen Endex waarde gevonden voor geselecteerde datum. Gelieve een andere datum te selecteren!', MessageSeverity.error);
                }
            }
            this.loadingEndex = false;
        }, error => {
            this.loadingEndex = false;
            this.ngxLogger.error(error.message);
            throw error;
        });
        this.subscribers.push(getEndexSubscriber);
    }

    private setTrialUserEndex(isInit: boolean) {
        this.loadingEndex = true;
        const contractDate = moment("2016-03-14").format("YYYY-MM-DD");
        const getEndexByDateSubscriber = this.electricityContractService.getEndexByDate(contractDate).subscribe((res: number) => {
            if (res > 0) {
                this.electricityContract.Endex = res;
            } else {
                this.electricityContract.Endex = null;
                if (!isInit) {
                    this.alertService.showMessage('Elektriciteitscontract', 'Geen Endex waarde gevonden voor geselecteerde datum. Gelieve een andere datum te selecteren!', MessageSeverity.error);
                }
            }
            this.loadingEndex = false;
        }, error => {
            this.loadingEndex = false;
            this.ngxLogger.error(error.message);
            throw error;
        });
        this.subscribers.push(getEndexByDateSubscriber);
    }

    onDateChange(value: Date) {
        if (moment(value).isAfter(this.electricityContract.ContractBase.ContractStartDate)) {
            this.electricityContract.ContractBase.ContractStartDate = value;
        }
    }

    onStartDateChange(value: Date) {
        if (moment(value).isAfter(this.electricityContract.ContractBase.ContractEndDate)) {
            this.electricityContract.ContractBase.ContractEndDate = value;
        }
    }

    ngOnDestroy() {
        if (this.subscribers) {
            this.subscribers.forEach(s => s.unsubscribe());
        }
    }

    showErrorAlert(caption: string, message: string) {
        this.alertService.showMessage(caption, message, MessageSeverity.error);
    }

    get caninjectionContractAddPermission() {
        return this.accountService.userHasPermission(Permission.injectionContractAddPermission);
    }

    get caninjectionContractEditPermission() {
        return this.accountService.userHasPermission(Permission.injectionContractEditPermission);
    }

    get caninjectionContractDeletePermission() {
        return this.accountService.userHasPermission(Permission.injectionContractDeletePermission);
    }

    get caninjectionContractViewPermission() {
        return this.accountService.userHasPermission(Permission.injectionContractViewPermission);
    }

    get caninjectionContractListPermission() {
        return this.accountService.userHasPermission(Permission.injectionContractListPermission);
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/electricity/injectie-contract/injectie-contract.component.ts